<template>

    <div class="text-center text-gray-900 bg-opacity-50 rounded-lg bp-4 sm:mt-0 sm:col-span-2">
        <div class="px-4 py-8 mx-auto text-left sm:py-6 sm:px-6 lg:px-5 rounded-2xl" id="show-opp-near">
            <h4 class="text-lg font-extrabold tracking-tight text-sa-raspberry-900 sm:text-xl lg:text-lg"
                id="learning-mod">Newest Guides</h4>

            <div class="mt-4 text-sm text-sa-raspberry-600" v-if="isFetching">
                Loading...
            </div>
            <div v-else
                class="grid grid-cols-1 pb-5 mt-4 gap-x-4 md:gap-x-5 md:gap-y-1 gap-y-3 sm:grid-cols-3 md:grid-cols-5">
                <div class="opp-near-card" v-for="guide in recentGuides" :key="guide.id">
                    <div v-if="guide.id.startsWith('shows')" class="flex items-start space-x-4 text-base sm:text-sm">
                        <div class="flex-none mt-1">
                            <a :href="`/${guide.urlSlug}`" :alt="guide.title" :title="guide.title">
                                <img class="object-cover w-8 rounded-lg shadow-lg" :src="guide.logo"
                                    :alt="`${guide.title} logo`" :title="`${guide.title} logo`">
                            </a>
                        </div>
                        <div class="flex-grow">
                            <a class="block font-medium hover:underline text-sa-raspberry-900"
                                :href="`/${guide.urlSlug}`" :alt="guide.title" :title="guide.title">
                                <h3>{{guide.title}}</h3>
                            </a>
                            <dl class="text-sa-raspberry-600">
                                <dt class="sr-only">Type</dt>
                                <dd><span class="text-xs">Show Research</span></dd>
                            </dl>
                        </div>
                    </div>

                    <div v-if="guide.id.startsWith('learn')" class="flex items-start space-x-4 text-base sm:text-sm">
                        <div class="flex-none mt-1">
                            <a v-if="guide.imageUrl" :href="`/${guide.id}/${guide.slug}`" :alt="guide.topic"
                                :title="guide.topic">
                                <img class="object-cover w-8 rounded-lg shadow-lg" :src="guide.imageUrl"
                                    :alt="guide.topic" :title="guide.topic">
                            </a>
                        </div>
                        <div class="flex-grow">
                            <a class="block font-medium hover:underline text-sa-raspberry-900"
                                :href="`/${guide.id}/${guide.slug}`" :alt="guide.topic" :title="guide.topic">
                                <h3>{{ guide.topic }}</h3>
                            </a>
                            <dl class="text-sa-raspberry-600">
                                <dt class="sr-only">Type</dt>
                                <dd><span class="text-xs">Learning Module</span></dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetNewestGuidesRequest, GetNewestGuidesResponse
} from "@/dtos";

const recentGuides = ref([]);

onMounted(async () => {
    await getNewestGuides();
});

const isFetching = ref(true);
const getNewestGuides = async () => {
    await client.get<GetNewestGuidesResponse>(new GetNewestGuidesRequest())
        .then(response => {
            recentGuides.value = response.results;
            isFetching.value = false;
        });
}

</script>
<style>

</style>